let Backbone = require("backbone");
let _ = require("underscore");

let main = function (Backbone, _) {
    return Backbone.Model.extend({

        defaults: {
            pageSize: 10,
            offset: 0,
            collection: null
        },

        initialize: function (params) {
            this.listenTo(this, "change:pageSize", this.resetOffset);
            this.listenTo(this, "change:collection", this.toFirstPage);
        },

        getCount: function () {
            if (this.get("collection")) {
                return this.get("collection").length;
            } else {
                return 0;
            }
        },

        getMaxPage: function () {
            return Math.ceil(this.getCount() / this.get("pageSize"));
        },

        toIndexPage: function (index) {
            this.set({offset: Math.floor((index) / Math.floor(this.get("pageSize")))});
        },

        getPageCollection: function () {
            var offset = this.get("offset"),
                pageSize = this.get("pageSize"),
                begin = offset * pageSize,
                end = (offset + 1) * pageSize;

            if (this.get("collection")) {
                return new Backbone.Collection(this.get("collection").slice(begin, end));
            } else {
                return new Backbone.Collection();
            }
        },

        next: function () {
            if (this.hasNext()) {
                var offset = this.get("offset") + 1;
                this.set({"offset": offset});
            }
        },

        prev: function () {
            if (this.hasPrev()) {
                var offset = this.get("offset") - 1;
                this.set({"offset": offset});
            }
        },

        hasNext: function () {
            var pageSize = this.get("pageSize"),
                offset = this.get("offset"),
                count = this.getCount();
            if (pageSize * (offset + 1) < count) {
                return true;
            } else {
                return false;
            }
        },

        hasPrev: function () {
            var offset = this.get("offset");
            return offset > 0;
        },

        resetOffset: function () {
            var pageSize = this.get("pageSize"),
                offset = this.get("offset"),
                count = this.getCount();
            if (count > 0) {
                while (pageSize * offset >= count) {
                    offset -= 1;
                }
                this.set({offset: offset});
            }
        },

        toFirstPage: function () {
            this.set({offset: 0});
        },

        showPage: function () {
            return this.hasNext() || this.hasPrev();
        }
    });
};

let exportedValue = main(Backbone, _);
module.exports = exportedValue;


// WEBPACK FOOTER //
// ./src/model/BasePagingModel.js